module.exports = __webpack_public_path__ + "roboto-v15-latin-700.d792be547b564f8e9b8f.svg";


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/assets/layout/fonts/roboto-v15-latin-700.svg
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.svg
// module chunks = styles